module.exports = __webpack_public_path__ + "img/show-img4.bb677d4c.png";